<template>
<v-app light class="App">
    <router-view />
    <alert />
</v-app>
</template>

<script>
import AlertComponent from './components/shared/Alert'
export default {
    components: {
        alert: AlertComponent
    },
    name: 'App',
};
</script>

<style lang="scss">
@import "./global.scss";
</style>
